import { Language } from '@ha/intl';

export type { ApolloRouteShape as RouteShape } from 'ha/types/apollo/ApolloRouteShape';

export interface HermesState {
  info: HermesInfo | null;
  data: {} | null;
  error: boolean;
}

export enum SitemapStatus {
  EXCLUDE = 'exclude',
}

export interface HermesInfo {
  id: string;
  path: string;
  type: string;
  hasData: boolean;
  availableLanguages?: string[];
  meta: {
    alternateHrefs: { [lang: string]: string };
    canonical: string;
  };
  redirect?: string;
  sitemap?: SitemapStatus;
}

export interface HermesResponse {
  data?: object;
  info: HermesInfo;
}

export type LinkData =
  | {
      rel: 'canonical';
      href: string;
    }
  | {
      rel: 'alternate';
      href: string;
      hrefLang: string;
    };

export interface ShortCountryData {
  name: string;
  pathname: string;
  hasData: boolean;
  canonical: string;
}

export interface ShortCityData {
  name?: string;
  pathname?: string;
  hasData: boolean;
  canonical: string;
  mainPicture?: string;
  mainPictureAsset?: ContentfulImage;
  previewDescription?: string;
}

export type TopicCluster =
  | 'rentingAbroad'
  | 'movingAbroad'
  | 'livingIn'
  | 'studying'
  | 'working'
  | 'beforeTenancy'
  | 'caseStudy'
  | 'duringTenancy'
  | 'housingTrends'
  | 'rentalLaws';

export interface ShortBlogData {
  title: string;
  pathname: string;
  description: string;
  headerImage: string;
  headerImageAsset: ContentfulImage;
  topicCluster: TopicCluster;
}

export interface ContentfulImage {
  fields: {
    title?: { en: string };
    description?: { [key in Language]: string };
    url: string;
  };
}
